// Asset imports
import styles from "./ColorSchemeToggle.module.css";
import IconLightMode from "../../assets/lightmode.svg?react";
import IconDarkMode from "../../assets/darkmode.svg?react";

// General imports
import { ActionIcon, Tooltip, useComputedColorScheme, useMantineColorScheme } from "@mantine/core";

export function ColorSchemeToggle() {
	const { toggleColorScheme } = useMantineColorScheme({
		keepTransitions: true,
	});
	const computedColorScheme = useComputedColorScheme("light", {
		getInitialValueInEffect: true,
	});
	const nextColorScheme = computedColorScheme === "light" ? "dark" : "light";

	const renderIcon = () => {
		return nextColorScheme === "light" ? <IconLightMode /> : <IconDarkMode />;
	};

	return (
		<Tooltip label={`Switch to ${nextColorScheme} mode`}>
			<ActionIcon className={styles.root} size="xl" onClick={toggleColorScheme}>
				{renderIcon()}
			</ActionIcon>
		</Tooltip>
	);
}
